// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610160340/js/" + chunkId + "." + {"44":"54d89da3","225":"f58fdac3","481":"436a4eb7","486":"dcf29768","770":"2ebcde60"}[chunkId] + ".0.3000247996063662.chunk.js";
};